import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextBoxComponent } from './textbox.component';
/**
 * NgModule definition for the TextBox component.
 */
export class TextBoxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        TextBoxComponent
    ],
    exports: [
        TextBoxComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TextBoxModule_tsickle_Closure_declarations() {
/** @type {?} */
TextBoxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TextBoxModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
